import React from "react"
import Checkbox from './Checkbox';
import groupBy from 'lodash/groupBy';

const AuthorCheckboxes = ({handleSelectAdmin, users, recipients}) => {
  
  const renderCheckboxes = () => {
    const groups = groupBy(users, (user) => user.articleTitle)
    
    return Object.entries(groups).map(([title, group]) => (
      <div className="checkbox-group" key={title}>
        <p><strong>{title}</strong></p>
        {group.map((user) => (
          <Checkbox
            key={user.id}
            user={user}
            handleSelectAdmin={handleSelectAdmin}
            recipients={recipients}
          />
        ))}
      </div>
    ))
  }
  
  return (
    <div className="checkboxes">
      {renderCheckboxes()}
    </div>
  )
}

export default AuthorCheckboxes